<template>
  <div>
    <QueryForm ref="queryFormRef" @query="onQueryAction"> </QueryForm>

    <Viewport ref="viewPortRef" v-model="tableHeight">
      <el-table
        v-loading="tableLoading"
        class="common-el-table-styles"
        @sort-change="onTableSort"
        border
        stripe
        :data="tableData"
        :height="tableHeight"
      >
        <el-table-column prop="content" label="关键词"> </el-table-column>
        <el-table-column sortable="custom" prop="relatedMaterialsNum" width="120" label="关联素材数"> </el-table-column>
        <el-table-column prop="mGameNames" label="中间件游戏" show-overflow-tooltip> </el-table-column>
        <el-table-column sortable="custom" label="新建时间" prop="createTime"> </el-table-column>
        <el-table-column sortable="custom" label="更新时间" prop="upTime"> </el-table-column>
        <el-table-column label="操作" width="80">
          <template slot-scope="{ row }">
            <el-button type="text" @click="onTableRowAction(row)">查看素材</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pager">
        <el-pagination
          :current-page.sync="pager.pageId"
          :page-size.sync="pager.pageSize"
          :total="pager.total"
          :page-sizes="[30, 50, 100, 200]"
          @current-change="getTableData"
          @size-change="onQueryAction"
          layout="total, sizes, prev, pager, next, jumper"
          background
        >
        </el-pagination>
      </div>
    </Viewport>
  </div>
</template>
<script setup>
import { ref, onMounted, nextTick } from 'vue'
import { useRouter } from 'vue-router/composables'
import QueryForm from './components/tags/keyword-query-form.vue'
import { useTable } from './hooks/useTags.js'
import { LABEL_TYPES } from './const.js'

const router = useRouter()

const queryFormRef = ref(null)
const labelType = LABEL_TYPES.KEYWORD_LABEL
const { tableData, tableLoading, tableHeight, tableSortParams, pager, onQueryAction, getTableData } = useTable(queryFormRef, labelType)

const onTableRowAction = (row) => {
  router.push({
    name: 'librarymain',
    query: {
      queryType: 'ai',
      queryStr: encodeURIComponent(row.content)
    }
  })
}
const onTableSort = ({ prop, order }) => {
  tableSortParams.value.sort = prop
  tableSortParams.value.order = order.replace('ending', '')
  onQueryAction()
}
onMounted(() => {
  onQueryAction()
})
</script>
<style lang="scss" scoped>
.pager {
  text-align: right;
  padding: 5px 0;
}

.search-btn {
  display: flex;
  align-items: center;
}
.toggle-view-btn {
  display: flex;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  margin-left: 3px;
  background: #a9a9a9;
  &.active {
    background: #1974ff;
  }
}
</style>
